<script>

    import { createEventDispatcher } from "svelte"

    $: value = value || ''

    export let value = ''
    export let iconType = "fa"
    export let text = null
    export let options = []
    export let label = null
    export let icon = null
    export let required = true

    const dispatch = createEventDispatcher()

    function onChange() {
        dispatch("change", value)
        dispatch("selected", value)
    }
</script>

<style>
    select, .select {
        width: 100%;
    }
</style>

<div class="field">
    {#if label}
        <label for="" class="label">{label}</label>
    {/if}
    <div class="control has-icons-left">
        {#if icon}
            <span class="icon"><i class="fas {iconType}-{icon}" /></span>
        {/if}
        <div class="select" >
            <select bind:value={value} on:change={onChange} {required} >
                <option value="">{text || 'Selecciona una opción'}</option>
                {#each options as option}
                    <option value={option.value}>{option.text}</option>
                {/each}
            </select>
        </div>
    </div>
</div>